import type { HomeLauncherResponse } from '@coorum-research/shared-common/api-response'
import type { HomeLauncherItemConfig } from '@coorum-research/shared-common/types'
import {
  HomeLauncherContent,
  HomeLauncherContext,
  HomeLauncherFloatingPosition,
  HomeLauncherOverlay,
  HomeLauncherTrigger,
} from '@coorum-research/core/src/components/HomeLauncher'
import { useQuery } from '@tanstack/react-query'
import { useContext, useEffect, useRef, useState } from 'react'
import { campaignApi } from '../apis/campaign.api'
import { getResearchReactRootContainer, renderResearchPage } from '../utils/RenderResearchPage'
import { hideResearchPage } from './PageStoreProvider'

// ホームボタンコンテナ
export function HomeLauncherTriggerContainer({ homeLauncher }: {
  homeLauncher: HomeLauncherResponse
}) {
  const ref = useRef<HTMLDivElement | null>(null)

  if (!homeLauncher) {
    return null
  }

  return (
    <HomeLauncherFloatingPosition ref={ref} positionConfig={homeLauncher.configJson}>
      <HomeLauncherTrigger buttonDesign={homeLauncher.buttonDesign.configJson} />
    </HomeLauncherFloatingPosition>
  )
}

// ランチャーボタンコンテナ
export function HomeLauncherItemsContainer({ homeLauncher }: {
  homeLauncher: HomeLauncherResponse
}) {
  const { isOpen, onValueChange } = useContext(HomeLauncherContext)
  const { getCampaign } = campaignApi()
  const [item, setItem] = useState<HomeLauncherItemConfig | null>(null)
  const ref = useRef<HTMLDivElement | null>(null)

  const { data: campaign, isFetching: isFetchingCampaign } = useQuery({
    queryKey: ['get-campaign', item?.itemContent.id],
    queryFn: () => getCampaign(item?.itemContent.id ?? ''),
    refetchOnWindowFocus: false,
    enabled: item ? item.itemType === 'Campaign' : false,
  })

  useEffect(() => {
    // ランチャーボタン表示時にResearchPageを開いていたら閉じる
    if (isOpen) {
      const researchContainerEl = getResearchReactRootContainer()!
      hideResearchPage(researchContainerEl)
    }
  }, [isOpen])

  useEffect(() => {
    if (!campaign || isFetchingCampaign) {
      return
    }

    renderResearchPage({
      show: true,
      initPage: 'survey',
      campaign,
      onShow: () => {
        setItem(null)
        onValueChange(false)
      },
    })
  }, [campaign, isFetchingCampaign])

  const handleClickItem = (item: HomeLauncherItemConfig) => {
    setItem(item)

    switch (item.itemType) {
    case 'MyPage': // MyPageは情報取得なしに呼び出せる
      renderResearchPage({
        show: true,
        initPage: 'mypage',
        onShow: () => {
          setItem(null)
          onValueChange(false)
        },
      })
      break
    case 'Campaign':
      break
    }
  }

  if (!homeLauncher) {
    return null
  }

  return (
    <>
      <HomeLauncherOverlay />
      <HomeLauncherFloatingPosition ref={ref} positionConfig={homeLauncher.configJson}>
        <HomeLauncherContent items={homeLauncher.items} onClickItem={handleClickItem} popupPositionConfig={homeLauncher.configJson} />
      </HomeLauncherFloatingPosition>
    </>
  )
}
